<template>
  <header class="layout-default__header">
    <div class="layout-default__header__container">
      <RouterLink
        :to="{
          name: 'home',
          params: {
            doc: $route.meta.docDefault,
            version: latestVersion
          }
        }"
      >
        <img
          src="@/assets/images/playkids-learning-logo.png"
          alt="Logo PlayKids Learning"
          class="layout-default__header__logo"
        />
      </RouterLink>

      <div class="layout-default__header__tray">
        <RouterLink v-if="isDefaultView"
          :to="{
            name: 'home',
            params: {
              doc: 'privacy',
              version: 'center'
            }
          }"
        >
          {{ $t('privacyLink') }}
        </RouterLink>
        <RouterLink v-else
          :to="{
            name: 'home',
            params: {
              doc: $route.meta.docDefault,
              version: latestVersion
            }
          }"
        >
          {{ $t('privacyPolicy') }}
        </RouterLink>
        <DarkModeSwitcher />
        <LangSwitcher />
      </div>
    </div>
  </header>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'HeaderDefault',

  computed: {
    ...mapState('global', ['latestVersion']),
    isDefaultView () {
      return this.$route.params.doc !== 'privacy' || this.$route.params.version !== 'center'
    }
  },
  created: function () {
    console.log('a is: ', this.latestVersion)
  }
}
</script>
